import React from 'react';
import { Helmet } from 'react-helmet';

import LoginFormContainer from './components/presentational/LoginFormContainer';
import useScript from '../../shared/hooks/useScript';
import BackgroundSlidesPageContainer from './components/shared/BackgroundSlidesPageContainer';
import PageWrapper from './components/shared/PageWrapper';
import useBackgroundSlides, { createLoginSlides } from './components/hooks/useBackgroundSlides';
import useAuthCheck from './components/hooks/useAuthCheck';

const slides = createLoginSlides(12);

const Login = () => {
  useAuthCheck();
  const { imageTransition } = useBackgroundSlides(slides);

  useScript('https://cdn.ywxi.net/js/1.js');

  return (
    <BackgroundSlidesPageContainer
      imageTransition={imageTransition}
    >
      <Helmet>
        <title>Sign In | TeamBuildr</title>
      </Helmet>
      <PageWrapper>
        <LoginFormContainer />
      </PageWrapper>
    </BackgroundSlidesPageContainer>
  );
};

export default Login;
